import React from 'react';

export const isEmpty = (str) => {
  return !str || 0 === str.length;
};

export const isPasswordValid = (password) => {
  let isValid =
    !isEmpty(password) &&
    password.length >= 8 &&
    /\d/.test(password) &&
    /[~`!@#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?()\._]/.test(password) &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password);

  return isValid;
};

export const getDateFromFullDateString = (dateString) => {
  return dateString ? dateString.split(' ')[0] : null;
};

export function generateUUID(digits) {
  let str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVXZ';
  let uuid = [];
  for (let i = 0; i < digits; i++) {
      uuid.push(str[Math.floor(Math.random() * str.length)]);
  }
  return uuid.join('');
}